import { useOrgIntegrations } from "@/api/integrations";
import { useMemo } from "react";

/**
 * Hook to get the single Notion connection for the organization
 * Since there should only ever be one Notion connection per org,
 * this simplifies connection resolution for Notion pages
 */
export function useNotionConnection() {
  const { data: integrations, isLoading } = useOrgIntegrations();

  const result = useMemo(() => {
    if (!integrations) {
      return {
        connectionId: undefined,
        isLoading: true,
        hasConnection: false,
      };
    }

    // Find the single Notion connection
    const notionConnection = integrations.find(
      (i) => i.platform === "notion" && i.connected,
    );

    return {
      connectionId: notionConnection?.integration_connection_id,
      isLoading: false,
      hasConnection: !!notionConnection,
    };
  }, [integrations]);

  return {
    ...result,
    isLoading: isLoading || result.isLoading,
  };
}
